import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5920c28c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "axero-wiki-background" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "prev-next" }
const _hoisted_4 = { class: "prev-next-prev" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-arrow-left" }, null, -1 /* HOISTED */))
const _hoisted_6 = { class: "prev-next-next" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-arrow-right" }, null, -1 /* HOISTED */))
const _hoisted_8 = {
  key: 0,
  class: "attachments"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Attachments;", -1 /* HOISTED */))
const _hoisted_10 = ["href"]
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", {
        class: "articleH2",
        innerHTML: _ctx.currentWiki.ContentTitle
      }, null, 8 /* PROPS */, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.prevNextWiki.prev)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                class: "btn",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handlePrevNext(true)), ["prevent"]))
              }, [
                _hoisted_5,
                _createTextVNode(" Previous ")
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createVNode(_component_router_link, {
          to: { hash: '#pages' },
          class: "pages-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Pages ")
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.prevNextWiki.next)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                class: "btn",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handlePrevNext(false)), ["prevent"]))
              }, [
                _hoisted_7,
                _createTextVNode(" Next ")
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      (_ctx.currentWiki?.Attachments?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentWiki.Attachments, (attachment) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: attachment.FileID
                }, [
                  _createElementVNode("a", {
                    href: attachment.Path,
                    target: "_blank"
                  }, _toDisplayString(attachment.Caption), 9 /* TEXT, PROPS */, _hoisted_10)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        ref: "wiki",
        class: "axero-entity-formatted-content",
        innerHTML: _ctx.currentWiki.ContentBody
      }, null, 8 /* PROPS */, _hoisted_11)
    ])
  ]))
}